import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { MaterialReactTable } from 'material-react-table';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useEnumColumnData } from 'modules/common/enumTableColumn';

const theme = createTheme({
  palette: {
    primary: COLOR_PRIMARY,
    secondary: COLOR_SECONDARY,
    warning: COLOR_WARNING,
  },
});

/**
 * Shared read-only MaterialReactTable configuration for the dashboard grids.
 *
 * Pagination is enabled at 10 rows per page and the table container is never
 * height-constrained, so a full page of rows is always visible and the only
 * scrolling happens at the page level (no nested scrolling).
 */
const DashboardDataTable = ({ columns, data, initialSorting, ...materialReactTableProps }) => {
  const tableData = useEnumColumnData(data, columns);

  return (
    <ThemeProvider theme={theme}>
      <MaterialReactTable
        columns={columns}
        data={tableData}
        enablePagination
        enableStickyHeader={false}
        enableColumnOrdering={false}
        enableEditing={false}
        enableRowActions={false}
        muiTablePaperProps={{ elevation: 0, sx: { border: 'none', boxShadow: 'none' } }}
        muiTableContainerProps={{ sx: { maxHeight: 'none' } }}
        muiTablePaginationProps={{ rowsPerPageOptions: [10, 25, 50] }}
        initialState={{
          density: 'compact',
          pagination: { pageIndex: 0, pageSize: 10 },
          sorting: initialSorting,
        }}
        {...materialReactTableProps}
      />
    </ThemeProvider>
  );
};

DashboardDataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  initialSorting: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      desc: PropTypes.bool,
    }),
  ),
};

DashboardDataTable.defaultProps = {
  initialSorting: [],
};

export default DashboardDataTable;
